import wixarIcon from "src/assets/spatial_studio_icon.png";

interface WixarBadgeProps {
  /** Size variant — "sm" for inline pills, "md" for card/detail views */
  size?: "sm" | "md";
}

const WixarBadge = ({ size = "md" }: WixarBadgeProps) => {
  const imgSize = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";

  return (
    <img
      src={wixarIcon}
      alt="Wixar"
      title="Wixar"
      className={`${imgSize} rounded-sm flex-shrink-0`}
    />
  );
};

export default WixarBadge;
